"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var frac_1 = require("./frac");
exports.twoArgsCommands = Object.assign({}, frac_1.fracCmds, {
    "binom": true
});
function is2argsCommand(name) {
    return exports.twoArgsCommands.hasOwnProperty(name);
}
exports.is2argsCommand = is2argsCommand;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/latex-to-unicode-converter/ts-compiled/latex/commands/2args/index.js
// module id = 138
// module chunks = 0 1 2 3